import { AttributesMixin, define, Model } from "@type-r/models";

export interface AppConfig extends AttributesMixin<typeof AppConfig> { }

@define
export class AppConfig extends Model {
    static attributes = {
        fileStorageApiUrl: String,
        allowManualPaymentCreation: Boolean,
        enableEntitlementEnforcement: Boolean,
        csvPreviewRowsLimit : Number
    }

    static global: AppConfig;

    loadFrom(appConfig: any){
        this.fileStorageApiUrl = appConfig.file_storage_api_url;
        this.allowManualPaymentCreation = appConfig.allow_manual_payment_creation;
        this.enableEntitlementEnforcement = appConfig.enable_entitlement_enforcement;
        this.csvPreviewRowsLimit = appConfig.csv_preview_rows_limit;
    }
}

export const appConfig = (window as any)._appConfig = AppConfig.global = new AppConfig();
